import { useEffect, useState } from "react";
import {BuilderComponent, builder} from "@builder.io/react";
import {useHistory} from "react-router";

//if we later find that I broke this, the original code was from https://www.builder.io/c/docs/devtools-manual-react
export default function BuilderControlledPage() {
    const [content, setContent] = useState<BuilderComponent | undefined>(undefined);

    const history = useHistory();

    // get the page content from Builder
    useEffect(() => {
        async function fetchContent() {
            const content = await builder
                .get("page", {
                    url: window.location.pathname
                })
                .promise();

            setContent(content);

            // if the page title is found,
            // set the document title
            if (content?.data.title) {
                document.title = content.data.title
            }
        }
        fetchContent();
        // eslint-disable-next-line
    }, [window.location.pathname]);

    // return the page when found
    return (
        <>
            {/* Render the Builder page */}
            <BuilderComponent model="page"
                              content={content}
                              context={{ history }}
            />
        </>
    );
}